import React from "react";
import { isNumber } from "lodash";
import { Locale } from "@linkfluence/models/locale";
import Modal from "@ui-kit/modal";
import { tr } from "@radarly/i18n";
import { PasteID, PastePayload } from "@radarly/models/insight-pages/editor";
import PastedCards from "./pasted-cards";
import PastedFilters from "./pasted-filters";
import usePasteModalData from "./usePasteModalData";

export interface IProps {
  onClose: () => void;
  onApply: (data: PastePayload) => void;
  locale: Locale;
  type: PasteID;
}

const PasteModal = ({ onClose, onApply, locale, type }: IProps) => {
  const {
    filters,
    cards,
    onSelect,
    onValidate,
    selectedIndex,
    allowValidation,
  } = usePasteModalData(type, onApply);

  return (
    <Modal
      title={tr(locale, `INSIGHT_PAGES_EDITOR::${type}`)}
      onCancel={onClose}
      cancelLabel={tr(locale, "MODAL::CLOSE")}
      validateLabel={tr(locale, `FORM::PASTE`)}
      onValidate={allowValidation && onValidate}
      locale={locale}
      width="auto"
      isValid={isNumber(selectedIndex)}
    >
      {type === "paste_card" ? (
        <PastedCards
          cards={cards}
          onSelect={onSelect}
          locale={locale}
          selectedIndex={selectedIndex}
        />
      ) : (
        <PastedFilters
          filters={filters}
          onSelect={onSelect}
          locale={locale}
          selectedIndex={selectedIndex}
        />
      )}
    </Modal>
  );
};

export default PasteModal;
